import * as React from 'react';

import {InlineTab} from 'shells/tabs/inline-tabs/inline-tab';
import {InlineTabs} from 'shells/tabs/inline-tabs/inline-tabs';

import type {ContentType} from './audit-log-wrapper';

import styles from './audit-log.module.css';

type Props = {
    selectedTab: ContentType;
    onChange: (tab: ContentType) => void;
};

export function AuditLogTabs(props: Props) {
    return (
        <div className={styles.tabs}>
            <InlineTabs name='auditLog' selectedTab={props.selectedTab} onChange={props.onChange}>
                <InlineTab value='bulk-edits'>Bulk edits</InlineTab>
                <InlineTab value='logins'>User logins</InlineTab>
                <InlineTab value='list-actions'>List actions</InlineTab>
            </InlineTabs>
        </div>
    );
}
